export default "__VITE_ASSET__Dk2q0OP3__ 100w";